import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import Enums from '../../utils/enums';

@Injectable()

export class HotelAuthGuardService {

	constructor(private authService: AuthService,
		private router: Router,
		private settingsService: SettingsService
	) { }

	canActivate() {
		if (this.authService.getUserToken()) {
			return true;
		} else {
			this.router.navigate(['login']);
			return false;
		}
	}
}
